<template>
  <div
    :class="['fm-tree-item', { active: isActive }]"
    @click="$emit('navigate', node.uid)"
  >
    <span class="fm-tree-icon">📁</span>
    <span class="fm-tree-name">{{ node.name }}</span>
    <svg v-if="node.childs_count > 0" class="fm-tree-chevron" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'FMSidebarNode',
  props: {
    node: Object,
    currentPath: Array
  },
  computed: {
    isActive() {
      return this.currentPath.includes(this.node.uid)
    }
  }
}
</script>

<style scoped>
.fm-tree-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 8px;
  border-radius: var(--fm-radius-sm);
  cursor: pointer;
  transition: background 0.12s;
  font-size: 13px;
  color: var(--fm-text2);
}
.fm-tree-item:hover { background: var(--fm-surface3); color: var(--fm-text); }
.fm-tree-item.active { background: var(--fm-accent-glow); color: var(--fm-primary); font-weight: 500; }
.fm-tree-icon { font-size: 13px; flex-shrink: 0; }
.fm-tree-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.fm-tree-chevron { width: 13px; height: 13px; flex-shrink: 0; color: var(--fm-text3); }
</style>
